


























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import DimssaButton from "@/components/shared/dimssa-button.vue";

let streamFetch = function(url: string) {
  return fetch(url, {
    method: "get",
    mode: "cors",
    cache: "no-store"
  }).then(response => {
    if (!response.ok) {
      throw Error(response.status + " " + response.statusText);
    }

    if (!response.body) {
      throw Error("ReadableStream not yet supported in this browser.");
    }

    // for (const entry of response.headers.entries()) {
    //   console.log(entry);
    // }

    let contentLength = response.headers.get("Uncompressed-Content-Length");
    if (!contentLength) {
      console.log("Error: Uncompressed-Content-Length response header unavailable")
      // throw Error(
      //   "Uncompressed-Content-Length response header unavailable"
      // );
    }

    const total = contentLength ? parseInt(contentLength, 10) : 0;
    let loaded: number = 0;

    function progress(loaded: number, total: number) {
      //elProgress.innerHTML = Math.round(loaded/total*100)+'%';
      console.log(`progress: ${loaded} / ${total}`);
    }

    return new Response(
      new ReadableStream({
        start(controller) {
          const reader = response.body.getReader();

          read();
          function read() {
            reader
              .read()
              .then(({ done, value }) => {
                if (done) {
                  controller.close();
                  return;
                }
                loaded += value.byteLength;
                progress(loaded, total);
                controller.enqueue(value);
                read();
              })
              .catch(error => {
                console.error(error);
                controller.error(error);
              });
          }
        }
      })
    );
  });
};

@Component({
  components: { DimssaButton }
})
export default class SyncData extends Vue {
  animalsCount = 0;

  async countAnimals() {
    this.animalsCount = await this.$store.state.dataManager.getObjectStoreCount(
      "animals"
    );
  }

  restCalls: { [key: string]: string } = { //restCalls to objectStoreNames map
    "animals": "animals",
    GetAnimalMorbidities: "animal-morbidities",
    GetKraals: "kraals",
    GetLines: "lines",
    GetTreatments: "treatments",
    GetTreatmentCompositions: "treatment-compositions",
    GetMorbidityReasons: "morbidity-reasons",
    GetSpeciesCodes: "species-codes",
    GetDispensaryItems: "dispensary-items",
    GetReaderLocationDescriptions: "reader-location-descriptions",
    GetKraalMorbidities: "kraal-morbidities",
    GetKraalMorbidityHistories: "kraal-morbidity-histories",
    GetTagReaderLocationInfos: "tag-reader-location-infos"
  };

  async download() {
    console.log("download()");

    let objectStoreNames = Object.values(this.restCalls);
    for (let i = 0; i < objectStoreNames.length; i++) {
      this.$store.state.downloadStatus[objectStoreNames[i]].state = "idle";
    }

    await this.$store.state.dataManager.clearDatabase();
    console.log("database cleared")
    //this.fetchFromIndex(6)
    await this.fetchFromIndex(0); //"GetAnimals"
    // await this.fetchFromIndex(1); //"GetAnimalMorbidities"
    // await this.fetchFromIndex(2); //"GetKraals"
    // await this.fetchFromIndex(3); //"GetLines"
    // await this.fetchFromIndex(4); //"GetTreatments"
    // await this.fetchFromIndex(5); //"GetTreatmentCompositions"
    // await this.fetchFromIndex(6); //"GetMorbidityReasons"
    // await this.fetchFromIndex(7); //"GetSpeciesCodes"
    // await this.fetchFromIndex(8); //"GetDispensaryItems"
    // await this.fetchFromIndex(9); //"GetReaderLocationDescriptions"
    // await this.fetchFromIndex(10); //"GetKraalMorbidities"
    // await this.fetchFromIndex(11); //"GetKraalMorbidityHistories"
    // await this.fetchFromIndex(12); //"GetTagReaderLocationInfos"

    // let count = await this.$store.state.dataManager.getObjectStoreCount(
    //   "animals"
    // );
    // console.log(`animals count: ${count}`);
    // count = await this.$store.state.dataManager.getObjectStoreCount("kraals");
    // console.log(`kraals count: ${count}`);
  }

  fetchFromIndex(i: number) {
    //let url = "http://localhost:3570/WcfService.svc/";
    //let url = "http://192.168.88.73:3570/WcfService.svc/";
    let url = "http://localhost:8080/data/";
    let restCall: string = Object.keys(this.restCalls)[i];
    let urlFull = `${url}${restCall}`;
    let objectStoreName = this.restCalls[restCall];
    let app = this;
    console.log(`fetching ${urlFull}`);
    this.$store.state.downloadStatus[objectStoreName].state = "busy";
    return streamFetch(urlFull)
      .then(data => data.json())
      .then(data => {
        app.$store.state.downloadStatus[objectStoreName].state = "success";
        console.log("download completed");
        app.$store.dispatch("addItemsToDb", {
          objectStoreName: app.restCalls[restCall],
          items: data
        });
      })
      .catch(error => {
        app.$store.state.downloadStatus[objectStoreName].state = "error";
        console.error("error fetching data");
        console.error(error);
      });
  }
}
